import { useToast } from '@chakra-ui/react'
import useBrands from '../../../../hooks/useBrands'
import useConfigList from '../../../../hooks/useConfigList'
import useNavigateNext from '../../../../hooks/useNavigateNext'
import useUpdateReportDoc from '../../../../hooks/useUpdateReportDoc'
import useCurrentReport from '../../../../hooks/useCurrentReport'
import { NonSupMedicationsFormState } from '../utils/types'

export const useNonSupMedicationsFormState = (): NonSupMedicationsFormState => {
  const toast = useToast()
  const items = useConfigList('nonSupplementMedications')
  const brands = useBrands()
  const navNext = useNavigateNext()
  const updateReport = useUpdateReportDoc()
  const currentReport = useCurrentReport()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!currentReport?.medicationListIsAccurate) {
      toast({
        status: 'warning',
        title: 'Medication List Accurate?',
        description: `Please check the box confirming your medication list is currently accurate.`,
      })
      return false
    }
    updateReport({ nonSupplementMedications: true })
    navNext()
  }

  const lists = [
    {
      fieldId: 'nonSupplementMedicationId',
      label: 'Medication',
      items,
      id: 'nonSupplementMedications',
    },
    {
      fieldId: 'brandId',
      label: 'Brand',
      items: brands,
      id: 'brands',
    },
  ]

  return {
    handleSubmit,
    lists,
  }
}
